import LogoImage from "../assets/images/logo.png";

import axiosConfig from "./axiosConfig";
import Input from "./input";
import { useEffect, useState } from "react";

const LoginPage = (props) => {
  const [formdata, setFormdata] = useState({
    playcode: "",
  });
  const [feedback, setFeedback] = useState({
    status: 0,
    message: null,
    playcode: null,
  });
  const [sending, setSending] = useState(false);

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    const newFormdata = { ...formdata };
    newFormdata[name] = value;
    setFormdata(newFormdata);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    console.log("formData = ", formdata);
    try {
      setSending(true);
      let fetchUrl = "sabbat-login-page.php";
      console.log("FetchUrl = ", fetchUrl);
      const response = await axiosConfig.get(
        fetchUrl + "?playcode=" + formdata.playcode
      );

      console.log("Response = ", response.data);
      let NewFeedback = await response.data;
      setFeedback(NewFeedback);

      if (response.data.status === 1) {
        localStorage.setItem("playcode", response.data.playcode);
        props.history.replace("/SabbatReferee");
        // alert("Ok!");
      } else {
        alert(response.data.message);
      }
      setSending(false);
    } catch (error) {
      alert("مشکلی رخ داده است. دوباره سعی کنید!");
      setSending(false);
    }
  };

  const refereeLogin = () => {
    props.history.replace("/SideRefereeNew");
  };

  const monitorLogin = () => {
    props.history.replace("/SaloonMonitor");
  };

  const headLogin = () => {
    props.history.replace("/HeadReferee");
  };

  const resetLocalStorage = async () => {
    if (localStorage.getItem("refereeid") !== null) {
      console.log(`Local Storage found!`);
      let rid = localStorage.getItem("refereeid");
      let response = await axiosConfig("reset-referee.php?refereeid=" + rid);
      console.log(response.data);
      localStorage.removeItem("refereeid");
    } else {
      console.log(`Local Storage not found!`);
    }
    alert("حافظه لوکال برای این تبلت، ریست شد.");
  };

  const resetRefereeRecords = async () => {
    let rid = localStorage.getItem("refereeid");
    let response = await axiosConfig("reset-referees-records.php");
    console.log(response.data);
    alert(
      "اطلاعات داورها حذف شد. قبل از ورود بعنوان داور کنار، حتما بر روی، ریست این داور کنار، کلیک کنید."
    );
  };

  return (
    <section className="main-section">
      <div className="container-full">
        <div className="row text-center">
          <div className="col-12 mt-4">
            <img src={LogoImage} alt="logo" />
            <h6 className="mt-2 IRanSansBold">
              فدراسیون ووشو جمهوری اسلامی ایران
            </h6>
          </div>
        </div>
        <div className="row justify-content-md-center text-center mt-5 pb-5">
          <div className="col-md-6 col-sm-12">
            <div className="form-panel">
              <h6
                className="IRANSansNormal text-danger mb-3"
                style={{ fontSize: "13px" }}
              >
                برای ورود به پنل , کد مسابقه را
                وارد کنید.
              </h6>
              <form onSubmit={handleSubmit}>
                <Input
                  name="playcode"
                  type="text"
                  value={formdata.playcode}
                  label=""
                  onChange={handleChange}
                  placeHolder="کد مسابقه"
                />
                <div className="form-group mt-3 mb-2">
                  <button disabled={sending} className="btn btn-danger">
                    ورود به پنل
                  </button>
                </div>
              </form>
            </div>
            <div className="btnBox mt-3">
              {/* <button className="btn btn-info" onClick={this.saloonMonitor}>
                نمایشگر سالن
              </button>
              &nbsp;
              <button className="btn btn-primary" onClick={this.justMonitor}>
                هیت ژوری
              </button> */}
              <button className="btn btn-info" onClick={refereeLogin}>
                داور کنار
              </button>{" "}
              &nbsp;
              <button className="btn btn-primary" onClick={monitorLogin}>
                مانیتور سالن
              </button>{" "}
              &nbsp;
              <button className="btn btn-warning" onClick={headLogin}>
                هیت ژوری
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="resetThisReferee" onClick={resetLocalStorage}>
        ریست این داور کنار
      </div>
      <div className="resetRefereesRecords" onClick={resetRefereeRecords}>
        حذف همه داورها از بانک
      </div>
    </section>
  );
};

export default LoginPage;
